
export const powerautomate_info = 'Power Automate is an automation platform by Microsoft that allows you to create automated workflows between apps and services.'

export const powerautomate_md = `
# Microsoft Power Automate  
*Last updated on July 15, 2025*

## Overview

Microsoft Power Automate is a cloud-based automation platform included in the Microsoft 365 suite.
It allows you to create automated workflows between apps and services to synchronize files, get notifications, collect data, and reduce repetitive tasks.

## Benefits
- **Workflow Automation**: Automate routine business processes like approvals, alerts, or data syncing.
- **Minimal Coding**: Build flows using a simple drag-and-drop interface.
- **App Integration**: Connects with hundreds of services including Outlook, Excel, SharePoint, Teams, OneDrive, and external tools like Dropbox and Google Workspace.
- **Scheduled & Triggered Flows**: Run tasks on a schedule or in response to actions like receiving an email or a file upload.
- **Productivity Boost**: Helps reduce manual work and increases efficiency across teams.

## Requirements
- A user account with us
- Please contact our Help Desk so we can assign you a Power Automate license

## Getting Started
1. Go to [https://make.powerautomate.com](https://make.powerautomate.com)
2. Sign in with your company email.
    - Please note that you will need a specific license to use Power Automate. Please contact our Help Desk if you cannot log in.
3. Browse pre-built templates or click Create to start building your own flow.

Basic projects to start with:
- Sending notifications or approvals when a form is submitted
- Approving requests through Teams or Outlook
- Automatically saving email attachments to OneDrive

## Advanced Uses

Power Automate can support advanced workflows that go far beyond basic task automation. Below are examples of how it can be used to streamline operations, integrate systems, and enhance productivity across departments.

### Approval Workflows Across Departments
- Route document or form approvals through multiple levels (e.g., supervisor → manager → finance).
- Use dynamic approvers based on department, metadata, or user roles.
- Integrate with Microsoft Forms, SharePoint, or Power Apps for custom request and approval portals.

### AI-Powered Automation (using AI Builder)
- Extract data from scanned PDFs (e.g., invoices, receipts).
- Perform text analysis (sentiment detection, language recognition).
- Read structured forms and populate data automatically.

### Robotic Process Automation (available on Power Automate Desktop)
- Automate actions in legacy systems or desktop apps with no API access.
- Simulate human interaction (mouse clicks, keyboard input).

### Automated Data Collection & Reporting
- Pull survey or form data from Microsoft Forms, transform it, and send to Excel, Dataverse, or Power BI.
- Schedule recurring reports to be emailed automatically to team leads or managers.
- Aggregate updates from multiple SharePoint lists or libraries into a single dashboard.

## Support
- Contact our [IT Help Desk](https://it.bockwaterheaters.com/#/help)


`